<template>
  <div
    id="feAlert"
    class="modal fade"
    :class="datas.modalClass"
    role="dialog"
    ref="feAlert"
    :style="datas.modalStyle"
  >
    <div
      class="modal-dialog"
      :style="datas.modalDialogStyle"
      :class="{'alert-center': datas.showCenterDevice }"
    >
      <div class="modal-content" :class="datas.modalContentClass">
        <div class="close-dialog" v-if="datas.isShowClose">
          <svg
            @click="hide"
            aria-hidden="true"
            focusable="false"
            data-prefix="fas"
            data-icon="times-circle"
            role="img"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 512 512"
            class="icon-close svg-inline--fa fa-times-circle fa-w-16"
          >
            <path
              fill="currentColor"
              d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm121.6 313.1c4.7 4.7 4.7 12.3 0 17L338 377.6c-4.7 4.7-12.3 4.7-17 0L256 312l-65.1 65.6c-4.7 4.7-12.3 4.7-17 0L134.4 338c-4.7-4.7-4.7-12.3 0-17l65.6-65-65.6-65.1c-4.7-4.7-4.7-12.3 0-17l39.6-39.6c4.7-4.7 12.3-4.7 17 0l65 65.7 65.1-65.6c4.7-4.7 12.3-4.7 17 0l39.6 39.6c4.7 4.7 4.7 12.3 0 17L312 256l65.6 65.1z"
              class
            />
          </svg>
        </div>
        <div class="dialog-content border-0">
          <div class="modal-body" @class="!isReOrder ? dialog-body : '' ">
            <!-- <div class="form-group text-center cursor-default">
              <span>店舗モードに切り替えますか？</span>
              <p>ご利用の店舗 ID を入力してください。</p>
              <input
                type="text"
                id="insert-code"
                autofocus="autofocus"
                class="input-shop-code form-control"
              />
              <span class="text-danger invisible">店舗IDが存在しません</span>
            </div>-->
            <slot></slot>
          </div>
        </div>
        <div class="text-center row m-0">
          <slot name="action"></slot>
          <!-- <button class="btn-dialog col-6 border-top border-right">続ける</button>
          <button class="btn-dialog col-6 border-top border-left">キャンセル</button>-->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import JQuery from "jquery";
export default {
  props: {
    datas: {
      type: Object,
      required: true
    }
  },
  computed: {
    isShow() {
      return this.datas.isShow;
    }
  },

  methods: {
    show() {
      // alertComponent
      let opts = Object.assign(this.defaultOpts, this.datas.opts);
      JQuery(this.$el).modal(opts);
    },
    hide() {
      JQuery(this.$el).modal("hide");
      this.isReOrder = false;

      this.$emit("modal-close");
      return true;
    }
    // testThu() {
    //   console.log("testThu", this.$el);
    //   this.datas.isShow = false;
    //   JQuery(this.$el).modal("hide");
    // }
  },
  data() {
    return {
      defaultOpts: {
        keyboard: false,
        backdrop: "static"
      },
      isReOrder: false
    };
  }
};
</script>

<style  scoped>
.modal-dialog {
  padding: 10px;
}
.modal-content {
  padding: 10px;
  border-radius: 5px;
}
.text-center {
  justify-content: center;
}
.modal-body {
  padding: 0rem 1rem 1rem 1rem;
}
.close-dialog {
  padding: 0;
}
.alert-center {
  height: 100%;
  transform: translateY(30%) !important;
}
.unset-overflow {
  overflow: unset;
}
@media (max-width: 576px) {
  .modal-dialog {
    margin: 15px;
  }
}
.width-md {
  width: 75%;
}
@media (max-width: 767px) {
  .width-md {
    width: 100%;
  }
}
.width-md-a035 {
  width: 80%;
}
@media (max-width: 767px) {
  .width-md-a035 {
    width: 100%;
  }
}
</style>
